<style scoped>
	
	
	.line-box {
		display: flex; flex-direction: row;  align-items: center;
		margin-left: 30px;
	}
	.line-name {
		width: 130px; text-align: right; padding-right: 10px;
	}
	.line-tag-box {
		display: flex; flex-direction: row;  align-items: center;
		margin-left: 30px;
	}
	.line-tag {
		width: 700px;  background-color: #f2dede; color: #b94a48; line-height: 20px; padding: 10px; border-radius: 3px;
		margin-bottom: 30px;
	}
	
	.upload-box {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	
	
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 60px;
	    height: 60px;
	    line-height: 60px;
	    text-align: center;
	  }
	.avatar {
	    width: 60px;
	    height: 60px;
	    display: block;
	  }
	.rich-editor {
		width: 860px;
	}
	.rich-editor /deep/ .ql-editor {
		min-height: 360px;
	}
	.rich-editor /deep/ .ql-editor img {
		max-width: 100%;
		height: auto;
	}
	.rich-editor /deep/ .ql-editor img.selected-editor-image {
		outline: 2px solid #409EFF;
		outline-offset: 2px;
	}
	.image-size-panel {
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 10px;
		border: 1px solid #dcdfe6;
		border-top: 0;
		background: #f5f7fa;
	}
	.image-size-label {
		width: 70px;
		color: #606266;
	}
	.image-size-slider {
		width: 240px;
	}
</style>

<template>
	<div class="content">
		<div style="box-shadow: 1px 1px 10px #DCDCDC; height: 40px; background-color: white; display: flex; flex-direction: row; align-items: center; margin: 0 10px; padding: 5px 5px 5px 20px; border-radius: 10px;">
			<el-button icon="el-icon-refresh-right" circle  @click="getData" style="margin-right: 20px;"></el-button>
			
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item>首页</el-breadcrumb-item>
			  <el-breadcrumb-item>自定义广告</el-breadcrumb-item>
			  <el-breadcrumb-item>上传说明配置</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div style="background-color: white; margin: 10px; padding: 30px 0; border-radius: 10px;">
			<div style="display: flex; flex-direction: row;">
				<div class="line-name">上传说明配置：</div>
				<div class="rich-editor">
					<el-upload
						ref="editorImageUpload"
						style="display: none;"
						:action="this.$http_url + '/Upload/UploadImage'"
						:headers="headers"
						:show-file-list="false"
						:on-success="UploadSuccess"
						:on-error="UploadError"
						:before-upload="beforeUpload">
					</el-upload>
					<quill-editor
						ref="quillEditor"
						v-model="statement"
						:options="editorOptions"
						@ready="onEditorReady">
					</quill-editor>
					<div class="image-size-panel" v-if="imageSettingVisible" @mousedown.stop @click.stop>
						<span class="image-size-label">图片宽度</span>
						<el-slider
							class="image-size-slider"
							v-model="imageWidth"
							:min="10"
							:max="100"
							@input="setSelectedImageWidth">
						</el-slider>
						<span>{{ imageWidth }}%</span>
						<el-button size="mini" @click="setImageWidthPreset(25)">25%</el-button>
						<el-button size="mini" @click="setImageWidthPreset(50)">50%</el-button>
						<el-button size="mini" @click="setImageWidthPreset(75)">75%</el-button>
						<el-button size="mini" @click="setImageWidthPreset(100)">100%</el-button>
					</div>
				</div>
			</div>
			
			<div style="width: 100%; margin-top: 20px; margin-left: 140px;">
				<el-button style="width: 860px;" type="primary" @click="submit">提交保存</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	import { quillEditor } from 'vue-quill-editor';

	export default {
		components: { quillEditor },
		data(){
			return {
				statement:'',
				editorQuill:null,
				selectedImage:null,
				imageSettingVisible:false,
				imageWidth:100,
				headers:{
					Authorization:''
				},
				editorOptions:{
					theme:'snow',
					placeholder:'请输入上传说明配置...',
					modules:{
						toolbar:{
							container:[
								[{ 'font': [] }],
								[{ 'size': ['small', false, 'large', 'huge'] }],
								[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
								['bold', 'italic', 'underline', 'strike'],
								[{ 'script': 'sub' }, { 'script': 'super' }],
								[{ 'color': [] }, { 'background': [] }],
								[{ 'list': 'ordered' }, { 'list': 'bullet' }],
								[{ 'indent': '-1' }, { 'indent': '+1' }],
								[{ 'align': [] }],
								['blockquote', 'code-block'],
								['link', 'image', 'video'],
								['clean']
							],
							handlers:{
								image:()=>{
									this.selectEditorImage();
								}
							}
						}
					}
				}
			}
		},
		created(){
			this.headers.Authorization = localStorage.getItem('access_token');
			this.getData();
		},
		beforeDestroy(){
			if(this.editorQuill){
				this.editorQuill.root.removeEventListener('click', this.handleEditorClick);
			}
		},
		methods: {
			onEditorReady(quill){
				this.editorQuill = quill;
				quill.root.addEventListener('click', this.handleEditorClick);
			},
			handleEditorClick(e){
				if(e.target && e.target.tagName === 'IMG'){
					this.clearSelectedImage();
					this.selectedImage = e.target;
					this.selectedImage.classList.add('selected-editor-image');
					this.imageWidth = this.getImageWidthPercent(e.target);
					this.imageSettingVisible = true;
				}else{
					this.clearSelectedImage();
				}
			},
			clearSelectedImage(){
				if(this.selectedImage){
					this.selectedImage.classList.remove('selected-editor-image');
				}
				this.imageSettingVisible = false;
				this.selectedImage = null;
			},
			getImageWidthPercent(img){
				const editor = this.editorQuill && this.editorQuill.root;
				if(!editor || !img){
					return 100;
				}
				const editorWidth = editor.clientWidth || 1;
				const width = img.clientWidth || editorWidth;
				const percent = Math.round(width / editorWidth * 100);
				return Math.max(10, Math.min(100, percent));
			},
			setImageWidthPreset(width){
				this.imageWidth = width;
				this.setSelectedImageWidth(width);
			},
			setSelectedImageWidth(width){
				if(!this.selectedImage || !this.editorQuill){
					return;
				}
				this.selectedImage.setAttribute('style', 'width: ' + width + '%; height: auto; max-width: 100%;');
				this.selectedImage.removeAttribute('width');
				this.selectedImage.removeAttribute('height');
			},
			selectEditorImage(){
				const upload = this.$refs.editorImageUpload;
				const input = upload && upload.$el ? upload.$el.querySelector('input[type=file]') : null;
				if(input){
					input.click();
				}
			},
			beforeUpload(file){
			},
			UploadSuccess(res){
				if(res.code == 200)
				{
					const quill = this.$refs.quillEditor.quill;
					const range = quill.getSelection(true);
					quill.insertEmbed(range.index, 'image', this.$http_host + res.file_path);
					quill.setSelection(range.index + 1);
					this.$nextTick(()=>{
						const imgs = quill.root.querySelectorAll('img');
						const img = imgs[imgs.length - 1];
						if(img){
							this.clearSelectedImage();
							this.selectedImage = img;
							this.selectedImage.classList.add('selected-editor-image');
							this.imageWidth = this.getImageWidthPercent(img);
							this.imageSettingVisible = true;
						}
					});
				}else{
					return this.$message({ message: res.msg, type: 'warning' });
				}
			},
			UploadError(){
				return this.$message({ message: '上传失败，请重试', type: 'warning' });
			},
			getData(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '加载中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.get("/System/getDiyAdsConfig", {}).then(res=>{
					loading.close();
					if(res.code == 1)
					{
						_this.statement = res.data;
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			submit(){
				let _this = this;
				if(this.editorQuill){
					this.statement = this.editorQuill.root.innerHTML;
				}
				const loading = this.$loading({
						lock: true,
						text: '保存中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/System/setDiyAdsConfig", {statement:_this.statement}).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '保存成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
					
				}).catch(err=>{
					loading.close();
				});
			},
		},
	}
</script>
